export const CHECKOUT_URL = 'https://maxillar-en.impultienda.ar/checkout/';

export const MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/eNBqyLXvxFSP9ZEFh8FuVw/MOCKUP_MAXILLAR-EN.png';

export const AUTHOR_PHOTO_URL =
  'https://cdn.magicpatterns.com/uploads/wbgvPApFcuLrmY7bYZq1du/VALERIA_MONTES_-_BIOMECANICA.png';

export const heroBenefits = [
  '6 specialized clinical volumes covering the maxillary growth assessment pathway.',
  'Visual craniofacial growth maps and skeletal development diagrams.',
  'Structured assessment workflows for growing patients.',
  'Educational decision trees for recognizing skeletal discrepancies.',
  'Illustrated clinical scenarios and planning considerations.',
];

export const growthAreas = [
  'Craniofacial growth and developmental anatomy.',
  'Skeletal maturity and growth assessment.',
  'Maxillary and mandibular relationship analysis.',
  'Recognition of developing dentofacial discrepancies.',
  'Foundations of orthopedic planning.',
  'Clinical documentation and longitudinal follow-up.',
];

export const offerItems = [
  { label: 'Complete 6-Volume Clinical Blueprint', value: 97, isBonus: false },
  { label: 'Maxillary Expansion Visual Guide™', value: 19, isBonus: true },
  { label: 'Functional Orthopedic Appliance Atlas™', value: 24, isBonus: true },
  { label: 'Skeletal Class II & III Assessment Maps™', value: 21, isBonus: true },
  { label: 'Pediatric Dentofacial Red Flags Checklist™', value: 17, isBonus: true },
  { label: 'Growth Monitoring & Clinical Records Workbook™', value: 27, isBonus: true },
];

export const offerIncludes = [
  'All 6 specialized clinical volumes.',
  'All 5 exclusive clinical bonuses.',
  'Illustrated educational workflows.',
  'Printable assessment and planning resources.',
  'Digital PDF materials.',
  'A structured reference for studying growing patients.',
];

export const finalRecap = [
  'Craniofacial growth foundations.',
  'Skeletal maturity assessment.',
  'Maxillomandibular relationships.',
  'Dentofacial diagnostic frameworks.',
  'Orthopedic planning principles.',
  'Clinical follow-up and growth monitoring.',
];

export const scarcity = {
  spotsLeft: 7,
  filledPercent: 93,
};
